import Image from 'next/image';
import Link from 'next/link';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import i18n from '@/settings/i18n';

const t = i18n.init('homepage');

const DefaultHero = () => {
  const leftSection = getEdgeUrl('images/homepage/banner/v2/left-section.png');
  const rightSection = getEdgeUrl(
    'images/homepage/banner/v2/right-desktop.png',
  );
  const iphoneImage = getEdgeUrl('images/homepage/banner/v2/iphone.png');
  const switchImage = getEdgeUrl('images/homepage/banner/v2/switch.png');
  const smartwatchImage = getEdgeUrl(
    'images/homepage/banner/v2/smartwatch-v2.png',
  );

  return (
    <Link
      href="/collections/hot-deals"
      prefetch
      className="relative flex
     h-full w-screen flex-col items-center justify-center overflow-hidden bg-teal-500 text-gray-700"
    >
      {/* Left Block  */}
      <div className="absolute bottom-0 hidden md:left-[-140px] md:block lg:left-[-130px] xl:left-[-40px]">
        <div className="h-[200px] lg:h-[250px]">
          <Image
            src={leftSection}
            alt="Left Section"
            loading="eager"
            height={490}
            width={1186}
            sizes="384px"
            className="h-full w-auto"
            priority
            quality={80}
          />
        </div>
      </div>
      {/* Right Block */}
      <div className="absolute bottom-0 hidden md:right-[-320px] md:block lg:right-[-185px] xl:right-[-55px]">
        <div className="h-[280px]">
          <Image
            src={rightSection}
            alt="Right Section"
            loading="eager"
            height={490}
            width={1110}
            sizes="384px"
            className="h-full w-auto"
            priority
            quality={80}
          />
        </div>
      </div>
      {/* iPhone */}
      <div className="absolute bottom-0 left-0 md:hidden">
        <div className="h-[110px] sm:h-[150px]">
          <Image
            src={iphoneImage}
            alt="iPhone"
            loading="eager"
            height={258}
            width={297}
            sizes="94px"
            className="h-full w-auto"
            priority
            quality={50}
          />
        </div>
      </div>
      {/* Smartwatch */}
      <div className="absolute bottom-0 right-0 md:hidden">
        <div className="h-[130px] xs:h-[150px]">
          <Image
            src={smartwatchImage}
            alt="Smartwatch"
            loading="eager"
            height={280}
            width={410}
            sizes="94px"
            className="h-full w-auto"
            priority
            quality={50}
          />
        </div>
      </div>
      {/* Nintendo Switch */}
      <div className="absolute right-[-70px] top-[-20px] xxs:right-[-30px] xs:right-0 md:hidden">
        <div className="h-[110px] sm:h-[120px]">
          <Image
            src={switchImage}
            alt="Nintendo Switch"
            loading="eager"
            height={188}
            width={266}
            sizes="96px"
            className="h-full w-auto"
            priority
            quality={50}
          />
        </div>
      </div>
      <div className="relative">
        <div className="reebelo-container">
          <div className="flex flex-col items-center justify-center">
            <h1 className="mt-1.5 text-center text-lg font-bold leading-tight xxs:text-xl xs:text-2xl md:text-3xl">
              {t`Certified Refurbished for You`}
            </h1>
            <p className="text-sm xxs:text-base xs:text-lg md:text-xl">
              {t`Premium quality, low price.`}
            </p>
            <div className="mt-5 flex h-8 items-center justify-center rounded-full border-2 border-gray-700 !bg-gray-700 px-5 text-xs font-bold text-white sm:mt-5">
              {t`Shop Deals`}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default DefaultHero;
